import React, { useEffect, useState } from "react";
import ClayLayout from "@clayui/layout";
import "./AttractionForm.css";
import MultiStep from "../../components/MultiStep/MultiStep";
import AttractionBasicDetail from "../../components/AttractionComponents/AttractionBasicDetail/AttractionBasicDetail";
import { Attraction_FORM_STEPS } from "../../utils/Config";
import OtpVerification from "../../components/OtpVerification/OtpVerification";
import AttractionFinalScreen from "../../components/AttractionComponents/AttractionFinalScreen/AttractionFinalScreen";
import AttractionBusinessDetail from "../../components/AttractionComponents/AttractionBusinessDetail/AttractionBusinessDetail";
import Loader from "../../generic-components/loader/Loader";
interface AttractionFormProps {
  isExpansion: boolean
}
const AttractionForm: React.FC<AttractionFormProps> = ({ isExpansion }) => {
    const [step, setStep] = useState(0);
    const [resStatusMessage, setResStatusMessage] = useState('');
    const [inquiry, setInquiry] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleLoadingChange = (loading: boolean) => {
        setIsLoading(loading);
    };

    return (
        <ClayLayout.ContentSection className="contact_container">
            {isLoading && <Loader />}
            <ClayLayout.Row justify="start" className="contact_main">
                <ClayLayout.Col sm={12} lg={12} className="contact_form">
                    {step !== 3 && (
                        <MultiStep
                            step={step}
                            setStep={setStep}
                            steps={Attraction_FORM_STEPS}
                        />
                    )}
                    {step === 0 && (
                        <div className="personal-info-height pr-2">
                            <AttractionBasicDetail
                                setStep={setStep}
                                onLoadingChange={handleLoadingChange}
                            />
                        </div>
                    )}
                    {step === 1 && (
                        <OtpVerification
                            setStep={setStep}
                            btnUi="green"
                            onLoadingChange={handleLoadingChange}
                        />
                    )}
                    {step === 2 && (
                        <div className="personal-info-height pr-2">
                            <AttractionBusinessDetail
                                setStep={setStep}
                                setInquiry={setInquiry}
                                setResStatusMessage={setResStatusMessage}
                                onLoadingChange={handleLoadingChange}
                            />
                        </div>
                    )}
                    {step === 3 && (
                        <AttractionFinalScreen
                            setStep={setStep}
                            inquiry={inquiry}
                            resStatusMessage={resStatusMessage}
                        />
                    )}
                </ClayLayout.Col>
            </ClayLayout.Row>
        </ClayLayout.ContentSection>
    );
};

export default AttractionForm;